
  export default class CSRFactoryModel {
    constructor(options) {
      this.data = options.data;
    }

    getId() {
      return this.data.factory_id;
    }

    getTemplateData() {
      return this.data;
    }
  };

